var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.94737H10.5V1.47368C10.5 0.655789 9.8325 0 9 0H6C5.1675 0 4.5 0.655789 4.5 1.47368V2.94737H1.5C0.6675 2.94737 0.00749999 3.60316 0.00749999 4.42105L0 12.5263C0 13.3442 0.6675 14 1.5 14H13.5C14.3325 14 15 13.3442 15 12.5263V4.42105C15 3.60316 14.3325 2.94737 13.5 2.94737ZM9 2.94737H6V1.47368H9V2.94737Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.be80f80e93abe565cf6603016bac07ea.svg";
export { ForwardRef as ReactComponent };